import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // User side
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

    // Admin side - .admin-content div ko scroll karo
    const adminContent = document.querySelector('.admin-content');
    if (adminContent) {
      adminContent.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;